// extracted by mini-css-extract-plugin
export default {"icons":"LoginIcon_icons__ngaeX","icons__auth":"LoginIcon_icons__auth__YAFK9","icons__auth_mobileMenu":"LoginIcon_icons__auth_mobileMenu__e6RKQ"};